/// <reference path="../notes/NoteDetailViewController.ts" />
/// <reference path="../AppHelper.ts" />

class TransferNoteDetailViewController extends NoteDetailViewController
{
    static newInstance() : TransferNoteDetailViewController {
        let vc = new TransferNoteDetailViewController("transfer-note-detail-view");
        vc.initWithResource("layout/transfernote/TransferNoteDetailView.html");
        return vc;
    }

    private editHeaderView:TransferDetailHeaderView = null;
    private noEditHeaderView:TransferDetailHeaderView = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.editHeaderView = MUIOutlet(this, "edit-header-view", "TransferDetailHeaderView");
        this.noEditHeaderView = MUIOutlet(this, "no-edit-header-view", "TransferDetailHeaderView");
    }

    protected updateUI(){        
        this.editHeaderView.note = this.stockNote as TransferNote;
        this.noEditHeaderView.note = this.stockNote as TransferNote;
        this.editHeaderView.hidden = this.stockNote.status == StockNoteStatus.Processed ? true : false;
        this.noEditHeaderView.hidden = this.stockNote.status == StockNoteStatus.Processed ? false : true;

        this.fetchedResultsController = null;
        this.tableView.reloadData();                                    
    }

    set fetchedResultsController(value){
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;
    
        this._fetchedResultsController = value;
    }
    
    get fetchedResultsController(){
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;
    
        let ad = MUIWebApplication.sharedInstance().delegate;

        let sortDescriptors = [MIOSortDescriptor.sortDescriptorWithKey('orderIndex', true)];
        let fetchRequest = DBHelper.listFetchRequestWithEntityName("TransferNoteLine", sortDescriptors, 'note.identifier == ' + this.stockNote.identifier);
        //fetchRequest.relationshipKeyPathsForPrefetching = ["product.taxBuy", "product.tax", "product.stockInputFormats", "product.category", "product.supplierProducts"];
        fetchRequest.relationshipKeyPathsForPrefetching = ["tax", "inputFormat", "product.defaultWarehouse"];

        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;
    
        fetchedResultsController.performFetch();
    
        this._fetchedResultsController = fetchedResultsController;    
        return this._fetchedResultsController;
    }
        
    private showProcessView(){
        let alert = new MUIAlertViewController();
        alert.initWithTitle(MIOLocalizeString('PROCESS','PROCESS'), MIOLocalizeString("DO_YOU_WANT_TO_PROCCES?", "DO YOU WANT TO PROCCES?"), MUIAlertViewStyle.Default);
        alert.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('YES', 'YES'), MUIAlertActionStyle.Default, this, function(){
            this.stockNote.isProcessed = true;
            this.saveMovementNote();
        }));
        alert.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString('NO', 'YES'), MUIAlertActionStyle.Default, null, null));
       
        this.presentViewController(alert, true);
    }

}
